import {faPrint} from "@fortawesome/free-solid-svg-icons";
import printJS from "print-js";
import React, {useState} from "react";
import {Spinner} from "react-bootstrap";
import {useSelector} from "react-redux";

import { printEmpowermentV2Async } from "../../../../app/store/reducers/roaming/roamingEmpowermentV2Reducer";
import IconButton from "../../../common/IconButton";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";

const PrintEmpowermentV2 = ({id}) => {
    const [loading, setLoading] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    const onPrint = () => {
        setLoading(true);
        printEmpowermentV2Async(id)
            .then((response) => {
                setLoading(false);
                const blob = new Blob([response], {type: "application/pdf"});
                const blobUrl = window.URL.createObjectURL(blob);
                printJS(blobUrl);
            })
            .catch((err) => {
                setLoading(false);
            });
    };
    return (
        <IconButton
            variant="falcon-default"
            size="sm"
            icon={faPrint}
            onClick={onPrint}
            iconClassName="me-1"
            className="mx-2 mb-sm-0"
        >
            <span>{t(lang, "edi.common.button.print")}</span>
            {loading &&
                <Spinner
                    className="align-middle ms-2"
                    size="sm"
                    animation="border"
                    role="switch"
                />
            }
        </IconButton>
    );
};

export default PrintEmpowermentV2;
